import MapLibreGL from "maplibre-gl";

type Entry = {
    marker: MapLibreGL.Marker;
    popup: MapLibreGL.Popup;
};

const registry = new Map<any, Entry>();

function initialize(
    dotNetHelper: any,
    marker: MapLibreGL.Marker,
    popupEl: HTMLElement,
    options: MapLibreGL.PopupOptions
) {
    const popup = new MapLibreGL.Popup({
        offset: 16,
        closeButton: false,
        ...options
    })
        .setMaxWidth("none")
        .setDOMContent(popupEl);

    marker.setPopup(popup);

    registry.set(dotNetHelper, {
        marker,
        popup
    });
}

function close(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { popup } = entry;

    popup.remove();
}

function destroy(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { marker } = entry;

    marker.setPopup(null);

    dotNetHelper.dispose();

    registry.delete(dotNetHelper);
}

export default {
    initialize,
    close,
    destroy
}